import { render } from "./DaysForm.vue?vue&type=template&id=1f754add&scoped=true"
import script from "./DaysForm.vue?vue&type=script&lang=js"
export * from "./DaysForm.vue?vue&type=script&lang=js"

import "./DaysForm.vue?vue&type=style&index=0&id=1f754add&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f754add"]])

export default __exports__